<!-- 页脚组件 -->
<template>
   <div class="footer df-divide-equally" style="justify-content: space-around;" >
     <div v-if="$route.path==='/monitorRptIndexParent'" @click='changeTab(0)'>
       <span class="imgs1" :class="tableIndex==0? 'active1':''" ></span>
       <p :class="tableIndex==0? 'active':''">上报</p>
     </div>
     <div v-if="$route.path==='/areaRptIndexParent'" @click='changeTab(0)'>
       <span class="imgs3" :class="tableIndex==0? 'active3':''" ></span>
       <p :class="tableIndex==0? 'active':''">进度</p>
     </div>
     <div @click='changeTab(1)'>
       <span class="imgs2" :class="tableIndex==1? 'active2':''" ></span>
       <p :class="tableIndex==1? 'active':''">统计</p>
     </div>
   </div>
</template>

<script>
  import {mapState, mapGetters } from 'vuex'
  export default {
    props:['pageName'],
    data() {
      return {
        tableIndex:0
      }
    },
    computed: {
      ...mapState({
        _userInfo: (state) => state.InvestorInfo
      })
    },
    created() {},
    methods: {
      changeTab(index){
        console.log(this.pageName,'pageName');
        if(index == 1){
          let dateObj = JSON.parse(localStorage.getItem('dateObj'))
          if(this.pageName == 'hospitalStatistics' && new Date(dateObj.hospitalDate.replace(/\-/g, '/')).getTime()>new Date().getTime()){
            this.$toast(`将于${dateObj.hospitalDate}开启查询通道`);
            return
          }
          if(this.pageName == 'areaStatistics' && new Date(dateObj.areaDate.replace(/\-/g, '/')).getTime()>new Date().getTime()){
            this.$toast(`将于${dateObj.areaDate}开启查询通道`);
            return
          }
        }
        // 统计的时候去友盟埋点
        if(index == 1) {
          let userData = this._userInfo.data
          this.utils.cnzzStat('H5-全国手卫生监测专项报告-医疗机构','查看报告(Um_Event_ReadReport)',`${userData.userId}-${userData.postName}-${userData.comName}-${userData.isSign == '1' ? '已签约': '未签约'}-${userData.comProvinceName}`)
        }
        this.tableIndex = index
        this.$emit('changeBottomTab',index)
      }
    },
  }
</script>
<style lang='scss' scoped>
    .footer {
      background-color: #fff;
      font-family: PingFang-SC-Medium, PingFang-SC;
      font-weight: 500;
      z-index: 999;
      -webkit-overflow-scroll: touch;
      div {
        height: 50px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
      }
      p {
        color: rgba(102, 102, 102, 1);
        font-size: 14px;
      }
      .active{
        font-size:14px;
        color:rgba(38,180,255,1);
      }
      .imgs1 {
        width: 25px;
        height: 25px;
        background: url('../../assets/images/reported-gray.png') no-repeat;
        background-size: 100%;
      }
      .imgs2 {
        width: 25px;
        height: 25px;
        background: url('../../assets/images/statistics-gray.png') no-repeat;
        background-size: 100%;
      }
      .imgs3 {
        width: 25px;
        height: 25px;
        background: url('../../assets/images/jindu-gray.png') no-repeat;
        background-size: 100%;
      }
      .active1 {
        width: 25px;
        height: 25px;
        background: url('../../assets/images/reported.png') no-repeat;
        background-size: 100%;
      }
      .active2 {
        width: 25px;
        height: 25px;
        background: url('../../assets/images/statistics.png') no-repeat;
        background-size: 100%;
      }
      .active3 {
        width: 25px;
        height: 25px;
        background: url('../../assets/images/jindu.png') no-repeat;
        background-size: 100%;
      }
    }
</style>
